import getMeta from 'mex_components/app/scripts/storage/getMeta';

export default function addEnhancedDataToCartTracking(data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'eec.add',
    ecommerce: {
      add: {
        actionField: {
          list: 'Shopping cart'
        },
        products: [{
          id: data.attributes.external_id,
          value: data.attributes.original_price_cents /100,
          name: getMeta('og:title'),
          category: getMeta('product:category'),
          variant: '',
          brand: getMeta('product:brand'),
          quantity: 1
        }]
      }
    }
  });
}
